import { ValueGetterParams } from 'ag-grid-enterprise';
import { DocumentReader } from 'src/app/modules/core/store/models';

export const buValueGetter = (params: ValueGetterParams) => {
  const field = params.colDef.cellRendererParams.schemaField;

  const reader = new DocumentReader(params.data);
  const value = reader.getFieldValue(field.systemName);

  return value;
};
